import ApiInstance from './apiInstance.js';
import ApiInstanceFhir from './apiInstanceFhir.js';
import ApiInstanceField from './apiInstanceField.js';
import CanonicalField from './canonicalField.js';
import CanonicalFieldType from './canonicalFieldType.js';
import Credential from './credential.js';
import CredentialGroup from './credentialGroup.js';
import DocumentTemplateConfiguration from './documentTemplateConfiguration.js';
import CredentialCheckout from './ehrCredentials/checkouts.js';
import EhrInstance from './ehrInstance.js';
import EhrInstanceAlert from './ehrInstanceAlert.js';
import EhrInstanceField from './ehrInstanceField.js';
import JobConfig from './jobConfig.js';
import JobValidation from './jobValidation.js';
import ManualJob from './manualJob.js';
import { BaseAPI, type Common } from '../common.js';
import PracticeConfigApiInstance from './practiceConfig/apiInstance.js';
import PracticeConfigEhrInstance from './practiceConfig/ehrInstance.js';
import PracticeConfig from './practiceConfig/index.js';
import Queue from './queue.js';

export class API extends BaseAPI {
  ApiInstance: ApiInstance;
  ApiInstanceField: ApiInstanceField;
  ApiInstanceFhir: ApiInstanceFhir;
  CanonicalFieldType: CanonicalFieldType;
  CanonicalField: CanonicalField;
  Credential: Credential;
  CredentialCheckout: CredentialCheckout;
  CredentialGroup: CredentialGroup;
  DocumentTemplateConfiguration: DocumentTemplateConfiguration;
  EhrInstance: EhrInstance;
  EhrInstanceAlert: EhrInstanceAlert;
  EhrInstanceField: EhrInstanceField;
  JobConfig: JobConfig;
  JobValidation: JobValidation;
  ManualJob: ManualJob;
  PracticeConfig: PracticeConfig;
  PracticeConfigApiInstance: PracticeConfigApiInstance;
  PracticeConfigEhrInstance: PracticeConfigEhrInstance;
  Queue: Queue;

  constructor(common: Common) {
    super(common);
    this.ApiInstance = new ApiInstance(common);
    this.ApiInstanceField = new ApiInstanceField(common);
    this.ApiInstanceFhir = new ApiInstanceFhir(common);
    this.CanonicalFieldType = new CanonicalFieldType(common);
    this.CanonicalField = new CanonicalField(common);
    this.Credential = new Credential(common);
    this.CredentialCheckout = new CredentialCheckout(common);
    this.CredentialGroup = new CredentialGroup(common);
    this.DocumentTemplateConfiguration = new DocumentTemplateConfiguration(common);
    this.EhrInstance = new EhrInstance(common);
    this.EhrInstanceAlert = new EhrInstanceAlert(common);
    this.EhrInstanceField = new EhrInstanceField(common);
    this.JobConfig = new JobConfig(common);
    this.JobValidation = new JobValidation(common);
    this.ManualJob = new ManualJob(common);
    this.PracticeConfig = new PracticeConfig(common);
    this.PracticeConfigApiInstance = new PracticeConfigApiInstance(common);
    this.PracticeConfigEhrInstance = new PracticeConfigEhrInstance(common);
    this.Queue = new Queue(common);
  }
}
